export default {
  props: {
    autoFetchOnChange: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleFilterChange(key, value) {
      const filter = this.filters.find((candidate) => (candidate.param || candidate.key) === key)
      if (!filter || !filter.param) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn(`${this.$options.name}: filtro "${key}" sem "param" na spec — alteração ignorada.`)
        }
        return
      }
      this.$emit('filter-change', { instance: this.instance, param: filter.param, value, autoFetch: this.autoFetchOnChange })
    },
    handleSubmit(value) {
      this.$emit('submit', { instance: this.instance, value })
    }
  }
}
